window.tinymce.PluginManager.add('line', function(editor) {
    let currentElement, currentElementRect, body, document, containerRect, elements = [];
    const mousemove = event => {
        if (!currentElement)
            return;
        const width = event.clientX - currentElementRect.left;
        const height = event.clientY - currentElementRect.top;
        let length = Math.sqrt(width * width + height * height);
        let angle = Math.atan2(height, width);
        if (event.altKey) {
            if (Math.abs(angle) <= Math.PI / 4) {
                angle = 0;
                length = Math.abs(width);
            }
            else if (Math.abs(angle) >= Math.PI / 4 * 3) {
                angle = Math.PI;
                length = Math.abs(width);
            }
            else if (angle > Math.PI / 4) {
                angle = Math.PI / 2;
                length = Math.abs(height);
            }
            else if (angle < -Math.PI / 4) {
                angle = -Math.PI / 2;
                length = Math.abs(height);
            }
        }
        currentElement.style.width = length + 'px';
        currentElement.style.transform = `rotateZ(${angle}rad)`;
    };
    const mouseup = event => {
        event.preventDefault();
        if (event.button === 1) {
            if (event.altKey) {
                if (elements.length) {
                    elements.pop();
                    currentElement.remove();
                    currentElement = elements[elements.length - 1];
                    currentElement.style.width = 0;
                    currentElement.style.height = '0';
                    currentElement.style.transform = '';
                    currentElementRect = currentElement.getBoundingClientRect();
                    currentElement.style.height = '2px';
                }
            }
            else {
                if (currentElement)
                    currentElement.remove();
                body.style.cursor = '';
                body.removeEventListener('mousemove', mousemove);
                body.removeEventListener('mouseup', mouseup);
            }
            return;
        }
        let left = event.clientX - containerRect.left;
        let top = event.clientY - containerRect.top;
        if (currentElement) {
            const width = event.clientX - currentElementRect.left;
            const height = event.clientY - currentElementRect.top;
            let length = Math.sqrt(width * width + height * height);
            let angle = Math.atan2(height, width);
            if (event.altKey) {
                if (Math.abs(angle) <= Math.PI / 4) {
                    angle = 0;
                    length = Math.abs(width);
                    top = currentElementRect.top - containerRect.top;
                }
                else if (Math.abs(angle) >= Math.PI / 4 * 3) {
                    angle = Math.PI;
                    length = Math.abs(width);
                    top = currentElementRect.top - containerRect.top;
                }
                else if (angle > Math.PI / 4) {
                    angle = Math.PI / 2;
                    length = Math.abs(height);
                    left = currentElementRect.left - containerRect.left;
                }
                else if (angle < -Math.PI / 4) {
                    angle = -Math.PI / 2;
                    length = Math.abs(height);
                    left = currentElementRect.left - containerRect.left;
                }
            }
            currentElement.style.width = length + 'px';
            currentElement.style.transform = `rotateZ(${angle}rad)`;
        }
        currentElement = document.createElement('DIV');
        currentElement.classList.add('mceNonEditable');
        currentElement.setAttribute('contenteditable', 'false');
        elements.push(currentElement);
        // currentElement = document.createElement('img');
        // currentElement.src = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="none" viewBox="0 0 1 1"> <path d="M0 0 L1 1"/></svg>';
        currentElement.style.position = 'absolute';
        currentElement.style.backgroundColor = 'black';
        currentElement.style.transformOrigin = '0 1px';
        currentElement.style.left = left + 'px';
        currentElement.style.top = top + 'px';
        currentElement.style.width = 0;
        currentElement.style.height = '0';
        body.appendChild(currentElement);
        currentElementRect = currentElement.getBoundingClientRect();
        currentElement.style.height = '2px';
        // body.removeEventListener('mousemove', mousemove);
        // body.removeEventListener('mouseup', mouseup);
    };
    editor.addButton('line', {
        tooltip: 'Line',
        onclick: () => {
            body = editor.getBody();
            document = editor.getDoc();
            containerRect = body.getBoundingClientRect();
            body.style.cursor = 'cell';
            body.addEventListener('mousemove', mousemove);
            body.addEventListener('mouseup', mouseup);
            elements = [];
        },
        icon: 'custom fa-timeline',
    });
});
